import React from 'react';
import { View, StyleSheet } from 'react-native';
import { UnifiedModal } from '@/components/common/UnifiedModal';

interface BottomSheetModalProps {
  visible: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  /** Whether to show close button even without title (for tooltips) */
  showCloseButton?: boolean;
}

/**
 * Bottom sheet modal that slides up from the bottom with gesture dismiss.
 * Backed by UnifiedModal with variant="sheet".
 */
export const BottomSheetModal: React.FC<BottomSheetModalProps> = ({
  visible,
  onClose,
  children,
  title,
  showCloseButton = false,
}) => {
  const shouldShowHeader = !!title || showCloseButton;

  return (
    <UnifiedModal
      visible={visible}
      onClose={onClose}
      variant="sheet"
      showHeader={shouldShowHeader}
      title={title}
      enableGestureDismiss
    >
      <View style={styles.content}>{children}</View>
    </UnifiedModal>
  );
};

const styles = StyleSheet.create({
  content: {
    paddingHorizontal: 24,
    paddingBottom: 8,
  },
});
